
export const educationData = [
    {
      id: 1,
      title: {
        en: "Software Engineering",
        fr: "Génie Logiciel"
      },
      institution: {
        en: "ENSA Khouribga",
        fr: "ENSA Khouribga"
      },
      period: "2023 - Present",
      description: {
        en: "This program focuses on advanced software development methodologies, algorithms, and system design. Students gain expertise in programming languages, database management, cloud computing, cybersecurity, and AI applications.",
        fr: "Ce programme se concentre sur les méthodologies avancées de développement logiciel, les algorithmes et la conception de systèmes. Les étudiants acquièrent une expertise dans les langages de programmation, la gestion de bases de données, l'informatique en nuage, la cybersécurité et les applications de l'IA."
      }
    },
    {
      id: 2,
      title: {
        en: "The Integrated Preparatory Cycle (CPI)",
        fr: "Le Cycle Préparatoire Intégré (CPI)"
      },
      institution: {
        en: "ENSA Khouribga",
        fr: "ENSA Khouribga"
      },
      period: "2021 - 2023",
      description: {
        en: "A two-year intensive program covering fundamental subjects in mathematics, physics, and computer science. It builds analytical thinking, problem-solving skills, and a solid foundation in engineering principles.",
        fr: "Un programme intensif de deux ans couvrant les matières fondamentales en mathématiques, physique et informatique. Il développe la pensée analytique, la résolution de problèmes et une base solide en principes d'ingénierie."
      }
    },
    {
      id: 3,
      title: {
        en: "Baccalaureate",
        fr: "Baccalauréat"
      },
      institution: {
        en: "May Zyada",
        fr: "May Zyada"
      },
      period: "May 2021",
      description: {
        en: "A high school diploma specializing in sciences, equipping students with knowledge in mathematics, physics, and chemistry. It also develops critical thinking and research abilities, essential for higher education in engineering.",
        fr: "Un diplôme de lycée spécialisé dans les sciences, offrant aux étudiants des connaissances en mathématiques, physique et chimie. Il développe également la pensée critique et les capacités de recherche, essentielles pour l'enseignement supérieur en ingénierie."
      }
    }
  ];
  